/* Zenith V8.9 - subtle motion for visible content only. No layout-blocking dependencies. */
(() => {
  'use strict';
  if (!document.documentElement || !('animate' in Element.prototype)) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const boot = () => {
    const body = document.body;
    if (!body?.classList.contains('zenith-minimal-theme')) return;

    // The homepage already has a separate, well-tested IntersectionObserver animation.
    // The rest of the site receives a light, one-shot entry animation; nothing is hidden upfront.
    if (!reduceMotion.matches && !window.Shopify?.designMode) {
      const intro = document.querySelector('[data-zm-home]') ? null : document.querySelector('main h1');
      const headerBrand = document.querySelector('.zm-header__brand');
      const play = (node, distance, delay) => {
        if (!node || node.dataset.zenithMotionPlayed) return;
        if (node.getBoundingClientRect().top > window.innerHeight || node.getBoundingClientRect().bottom < 0) return;
        node.dataset.zenithMotionPlayed = '1';
        node.animate(
          [{opacity: .83, transform: `translate3d(0, ${distance}px, 0)`},
           {opacity: 1, transform: 'translate3d(0, 0, 0)'}],
          {duration: 420, delay, easing: 'cubic-bezier(.2,.7,.2,1)'}
        );
      };
      // Avoid transform on the whole fixed/sticky header: only animate its brand text.
      play(headerBrand, 6, 0);
      play(intro, 12, 45);
      // On phones the original heavy hero reveal is disabled for speed;
      // a single subtle load animation remains, without hidden content.
      if (window.matchMedia('(max-width: 749px)').matches) {
        play(document.querySelector('[data-zm-home] .zm-hero__copy'), 9, 25);
      }

      const candidates = document.querySelectorAll(
        'main .zenith-proof__grid article, main .zenith-related-card, ' +
        'main .zenith-catalog-card, main .zenith-contact__form-card, ' +
        '.zm-footer__sal-row'
      );
      if ('IntersectionObserver' in window && candidates.length) {
        const io = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            if (reduceMotion.matches || !entry.target.isConnected) return;
            entry.target.animate([
              {opacity: .88, transform: 'translate3d(0, 12px, 0)'},
              {opacity: 1, transform: 'translate3d(0, 0, 0)'}
            ], {duration: 430, easing: 'cubic-bezier(.2,.7,.2,1)'});
          });
        }, {threshold: .08, rootMargin: '0px 0px -22px 0px'});
        candidates.forEach(el => io.observe(el));
        reduceMotion.addEventListener?.('change', () => io.disconnect(), {once: true});
      }
    }

    // Reflect current page in the minimal desktop navigation for accessibility.
    const current = location.pathname.replace(/\/$/, '') || '/';
    document.querySelectorAll('.zm-header__nav a').forEach(link => {
      const path = new URL(link.href, location.origin).pathname.replace(/\/$/, '') || '/';
      if (path === current) link.setAttribute('aria-current', 'page');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
})();
